import * as t from "io-ts";
import * as util from "../../shared/src/util";
import { isEnum } from "../../shared/src/validation/create/isEnum";

export const codec = t.union([
    t.literal("in_person"),
    t.literal("online"),
]);

export const values = util.typeValuesFromCodec(codec.types as Array<t.LiteralC<T>>);

export type T = t.TypeOf<typeof codec>;

export const validator = isEnum(values);
